export default "__VITE_ASSET__B$_e2Nx3__"